import { lazy } from "react";

const Index = lazy(() => import("./Member"));
const Invite = lazy(() => import("./Invite"));

export { Index, Invite };
